export const timePanelHeaderText = "TAa";
export const meetNowHeaderText = "UAa";
export const groupsPanelHeaderText = "VAa";
export default {timePanelHeaderText,meetNowHeaderText,groupsPanelHeaderText};